/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Highlight_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Add previous Event to Selected Events" |
*
* @param {Shortcut_Keys_Desc_Highlight_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_highlight_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Highlight_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Highlight_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'evenement precedent aux evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis zu den ausgewählten Ereignissen hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi l'evento precedente agli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить предыдущее событие в список выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar evento anterior a Eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将上一个事件添加到选定事件中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントに前のイベントを追加する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली घटना को चयनित घटनाओं में जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar evento anterior aos eventos selecionados")
	return /** @type {LocalizedString} */ ("Add previous Event to Selected Events")
});